import {
  CreateChatFormData,
  CreatedContext,
  CreatedContextOption,
} from '@choco-admin/types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ChocoSelect } from '../../../../components/FormComponents';

// Convert CreatedContext enum to select options
const chatCreatedContextToSelectOption = (
  context: CreatedContext
): CreatedContextOption => {
  let label: string;

  switch (context) {
    case CreatedContext.ADMIN:
      label = 'Admin Created';
      break;
    case CreatedContext.BUYER_CONCIERGE:
      label = 'Buyer Concierge';
      break;
    case CreatedContext.CHOCO_AI:
      label = 'Choco AI';
      break;
    default:
      label = context;
  }

  return {
    value: context,
    label,
  };
};

const dropdownValues = Object.values(CreatedContext).map(
  chatCreatedContextToSelectOption
);

export const ChatCreatedContextField: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreateChatFormData>();

  const errorMessage = errors.createdContext?.message as string | undefined;

  return (
    <div className="space-y-2">
      <Controller
        name="createdContext"
        control={control}
        render={({ field }) => (
          <ChocoSelect
            label="Created Context"
            placeholder="Select context..."
            options={dropdownValues}
            value={field.value?.value || ''}
            onSelectionChange={(selectedValue) => {
              if (selectedValue) {
                const selectedOption = dropdownValues.find(
                  (option) => option.value === selectedValue
                );
                if (selectedOption) {
                  field.onChange(selectedOption);
                }
              } else {
                field.onChange(null);
              }
            }}
            errorMessage={errorMessage}
            showDescriptions={false}
          />
        )}
      />

      <p className="text-sm text-default-500">
        Vendors are invoiced based on this field. Only make this change if you
        know what you are doing.
      </p>
    </div>
  );
};
